import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Alert } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { Helmet } from 'react-helmet-async';
import { DownloadFile } from '../../components/connected';
import { getFile, setFileError } from '../../actions';
import { PageProps } from '../../config/types';
import { Spinner } from '../../components/atoms';
import { getContextStores } from '../../context';
import styles from './styles.module.less';

const Files: React.FC<PageProps> = ({ renderMenuHeader }) => {
  const [searchParams] = useSearchParams();
  const { id } = useParams();

  /* Context  */
  const { fileState, fileDispatch } = getContextStores();
  const { imgSrc, error } = fileState;

  const { message, code } = error;
  const loaded = imgSrc || code || message;

  useEffect(() => {
    renderMenuHeader?.(
      <DownloadFile />,
    );
  }, [loaded]);

  useEffect(() => {
    const url = searchParams.get('url');

    if (id) {
      getFile(null, id, fileDispatch);
      return undefined;
    } if (url) {
      getFile(url, null, fileDispatch);
      return undefined;
    }

    setFileError(
      {
        message: 'No id or URL was provided',
        code: '',
      },
      fileDispatch,
    );

    return () => renderMenuHeader?.(null);
  }, []);

  return (
    <Content className={styles.content}>
      <Helmet title="image" />
      {!loaded && <Spinner />}
      {imgSrc && <img src={imgSrc} alt="YNOMIA HQ" />}
      {(code || message)
      && <Alert className="code-error" message={code} description={message} type="error" />}
    </Content>
  );
};

export default Files;
